import { defineStore } from "pinia";
import { asset_host, minuteVersion } from "@/settings/settings";

export const useDataStore = defineStore({
  id: 'data',

  state: () => ({
    loading: true,
    error: null,
    success: null,
    data: {}
  }),

  // persist: {
  //   pick: ['data'],
  // },

  actions: {
    prefetchData() {
      this.fetchData('rooms', `${asset_host}rooms.json?v=${minuteVersion}`);
    },

    async fetchData(key, url) {

      return new Promise((resolve, reject) => {
        if (typeof this.data[key] != "undefined") {
          // console.log("Local data is up to date");
          return resolve(this.data[key]);
        }

        // console.log(`fetchData for ${key} from ${url}`);

        fetch(url)
          .then((response) => {
            response.json()
              .then((data) => {
                this.data[key] = data;
                return resolve(this.data[key]);
              })
              .catch((error) => {
                return reject(error);
              });
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    startLoading() {
      this.setLoading(true);
    },

    stopLoading() {
      this.setLoading(false);
    },

    setLoading(loading) {
      this.loading = loading;
    },

    setError(error) {
      this.error = error;
    },

    setSuccess(success) {
      this.success = success;
    },

    async getRoomData(room_id) {
      if (!this.data.rooms || (this.data.rooms && !this.data.rooms[room_id])) {
        await this.fetchData('rooms', `${asset_host}rooms.json?v=${minuteVersion}`);
      }

      return this.data.rooms[room_id];
    }
  }
});